'use strict';
const _ = require('lodash');

const getErrorMessage = propertyName => `Load message data must include ${propertyName} of type string`;

function setElementoryArguments(args) {
  if (!args.baseUrl || typeof args.baseUrl !== 'string') {
    throw new Error(getErrorMessage('baseUrl'));
  }
  if (!args.queryParameters || typeof args.queryParameters !== 'string') {
    throw new Error(getErrorMessage('queryParameters'));
  }

  if (!self.elementorySupport) {
    self.elementorySupport = {};
  }

  self.elementorySupport.baseUrl = args.baseUrl;
  self.elementorySupport.queryParameters = args.queryParameters;
  self.elementorySupport.options = _.assign({}, self.elementorySupport.options, args.options);
}

module.exports = {
  setElementoryArguments
};
